/* tslint:disable */
/* eslint-disable */
/**
 * incidentsv2
 * incidentsv2
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { IncidentFollowupListEntry } from './IncidentFollowupListEntry';
import {
    IncidentFollowupListEntryFromJSON,
    IncidentFollowupListEntryFromJSONTyped,
    IncidentFollowupListEntryToJSON,
} from './IncidentFollowupListEntry';
import type { IncidentProtocolResponsiblePartyListEntry } from './IncidentProtocolResponsiblePartyListEntry';
import {
    IncidentProtocolResponsiblePartyListEntryFromJSON,
    IncidentProtocolResponsiblePartyListEntryFromJSONTyped,
    IncidentProtocolResponsiblePartyListEntryToJSON,
} from './IncidentProtocolResponsiblePartyListEntry';

/**
 * 
 * @export
 * @interface IncidentProtocolActionListEntry
 */
export interface IncidentProtocolActionListEntry {
    /**
     * 
     * @type {string}
     * @memberof IncidentProtocolActionListEntry
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof IncidentProtocolActionListEntry
     */
    incident_protocol_id: string;
    /**
     * 
     * @type {string}
     * @memberof IncidentProtocolActionListEntry
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof IncidentProtocolActionListEntry
     */
    description?: string;
    /**
     * 
     * @type {string}
     * @memberof IncidentProtocolActionListEntry
     */
    deadline?: string;
    /**
     * 
     * @type {boolean}
     * @memberof IncidentProtocolActionListEntry
     */
    is_optional: boolean;
    /**
     * 
     * @type {string}
     * @memberof IncidentProtocolActionListEntry
     */
    created_by: string;
    /**
     * 
     * @type {string}
     * @memberof IncidentProtocolActionListEntry
     */
    modified_by?: string;
    /**
     * 
     * @type {Date}
     * @memberof IncidentProtocolActionListEntry
     */
    modified_date?: Date;
    /**
     * 
     * @type {string}
     * @memberof IncidentProtocolActionListEntry
     */
    incomplete_followup_time?: string;
    /**
     * 
     * @type {Array<IncidentProtocolResponsiblePartyListEntry>}
     * @memberof IncidentProtocolActionListEntry
     */
    responsible_parties: Array<IncidentProtocolResponsiblePartyListEntry>;
    /**
     * 
     * @type {Array<IncidentFollowupListEntry>}
     * @memberof IncidentProtocolActionListEntry
     */
    followups?: Array<IncidentFollowupListEntry>;
    /**
     * 
     * @type {any}
     * @memberof IncidentProtocolActionListEntry
     */
    complete_followups?: any | null;
}

/**
 * Check if a given object implements the IncidentProtocolActionListEntry interface.
 */
export function instanceOfIncidentProtocolActionListEntry(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "id" in value;
    isInstance = isInstance && "incident_protocol_id" in value;
    isInstance = isInstance && "name" in value;
    isInstance = isInstance && "is_optional" in value;
    isInstance = isInstance && "created_by" in value;
    isInstance = isInstance && "responsible_parties" in value;

    return isInstance;
}

export function IncidentProtocolActionListEntryFromJSON(json: any): IncidentProtocolActionListEntry {
    return IncidentProtocolActionListEntryFromJSONTyped(json, false);
}

export function IncidentProtocolActionListEntryFromJSONTyped(json: any, ignoreDiscriminator: boolean): IncidentProtocolActionListEntry {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'incident_protocol_id': json['incident_protocol_id'],
        'name': json['name'],
        'description': !exists(json, 'description') ? undefined : json['description'],
        'deadline': !exists(json, 'deadline') ? undefined : json['deadline'],
        'is_optional': json['is_optional'],
        'created_by': json['created_by'],
        'modified_by': !exists(json, 'modified_by') ? undefined : json['modified_by'],
        'modified_date': !exists(json, 'modified_date') ? undefined : (new Date(json['modified_date'])),
        'incomplete_followup_time': !exists(json, 'incomplete_followup_time') ? undefined : json['incomplete_followup_time'],
        'responsible_parties': ((json['responsible_parties'] as Array<any>).map(IncidentProtocolResponsiblePartyListEntryFromJSON)),
        'followups': !exists(json, 'followups') ? undefined : ((json['followups'] as Array<any>).map(IncidentFollowupListEntryFromJSON)),
        'complete_followups': !exists(json, 'complete_followups') ? undefined : json['complete_followups'],
    };
}

export function IncidentProtocolActionListEntryToJSON(value?: IncidentProtocolActionListEntry | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'incident_protocol_id': value.incident_protocol_id,
        'name': value.name,
        'description': value.description,
        'deadline': value.deadline,
        'is_optional': value.is_optional,
        'created_by': value.created_by,
        'modified_by': value.modified_by,
        'modified_date': value.modified_date === undefined ? undefined : (value.modified_date.toISOString()),
        'incomplete_followup_time': value.incomplete_followup_time,
        'responsible_parties': ((value.responsible_parties as Array<any>).map(IncidentProtocolResponsiblePartyListEntryToJSON)),
        'followups': value.followups === undefined ? undefined : ((value.followups as Array<any>).map(IncidentFollowupListEntryToJSON)),
        'complete_followups': value.complete_followups,
    };
}

